import { faArrowRight, faEye, faEyeSlash, faArrowLeft, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState, useEffect } from 'react'
import { SERVER_URL } from '../../config';
import toast from 'react-hot-toast';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import GoogleTranslate from '../../GoogleTranslate';

export default function ClubLogin() {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const [errors, setErrors] = useState({});
    const [isLogin, setIsLogin] = useState(false);
    const clubToken = sessionStorage.getItem('club_token');

    useEffect(() => {

        const isValid = (token) => {
            if (!token) return false;
            try {
                const decoded = jwtDecode(token);
                return decoded.exp * 1000 > Date.now();
            } catch {
                return false;
            }
        };

        if (isValid(clubToken)) {
            navigate('/');
        }
    }, [clubToken]);

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const handleSubmit = async () => {
        try {
            const newErrors = {};

            if (!email.trim()) {
                newErrors.email = "Email is required";
            } else {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(email.trim())) newErrors.email = "Invalid email format";
            }

            if (!password) {
                newErrors.password = "Password is required";
            }

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }
            setErrors({});
            setIsLogin(true)

            const response = await axios.get(`${SERVER_URL}/api/v2/club-login?email=${email}&password=${password}`);
            if (response.data.status === true) {
                toast.success("Login successfully!");
                sessionStorage.setItem('club_token', response.data._token);
                setTimeout(() => {
                    navigate('/?source=club')
                }, 1500);
            }
        } catch (error) {
            console.error("Error during Login : ", error);
            toast.error(error.response?.data?.msg ? error?.response?.data?.msg : "Failed to Login. Please try again.");
        } finally {
            setIsLogin(false)
        }
    };

    return (
        <div className='lg:h-screen flex flex-col items-center justify-center bg-cover pt-10 lg:pt-0 overflow-hidden' style={{ backgroundImage: 'url("/assets/bg/Authbg.svg")' }}>
            <div className='flex justify-between w-full md:mb-0 mb-10'>
                <div className='w-[50%]'>
                    <button onClick={() => { window.location.href = '/' }} className=" cursor-pointer absolute top-5 left-5 flex items-center gap-2 text-white px-4 py-2 rounded-full">
                        <FontAwesomeIcon icon={faArrowLeft} />
                        <span >Back</span>
                    </button>
                </div>

                <div className='top-5 right-1 absolute'>
                    <GoogleTranslate />

                </div>
            </div>
            <div className='w-[90%] flex flex-col-reverse lg:flex-row items-center gap-10 text-white '>
                <div className='w-[100%] lg:w-[50%] relative'>
                    <h1 className='text-xl font-bold uppercase text-center'>Welcome To Goaldex</h1>
                    <img src='/assets/others/clublogin.svg' className='md:w-[80%] mx-auto' data-aos='flip-left' data-aos-duration='1500'></img>
                    <img src='/assets/others/Ball.svg' className='ball-spin w-[25%] absolute bottom-10 right-0 lg:hidden block' style={{ zIndex: 1 }} />
                </div>
                <div className='w-[100%] lg:w-[50%] relative'>
                    <div className='bg-white/5 lg:w-[90%] 2xl:w-[80%] 2xl:mx-auto p-7 lg:px-10 py-10 lg:py-20 2xl:py-24 brand-fade'>
                        <h1 className='text-center text-3xl md:text-5xl 2xl:text-6xl' style={{ fontFamily: 'Sacramento' }}>Login</h1>
                        <div className='w-[100%] md:w-[90%] mx-auto mt-5'>
                            <label className='font-semibold text-lg'>Email</label>
                            <input type='email'
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setEmail(value);

                                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                    setErrors((prev) => ({
                                        ...prev,
                                        email: value && !emailRegex.test(value.trim())
                                            ? "Invalid email format"
                                            : "",
                                    }));
                                }}
                                className='w-[100%] mt-1 border rounded outline-none py-2 px-3' required></input>
                            {errors.email && <p className="text-red-400 text-sm">{errors.email}</p>}

                        </div>
                        <div className='w-[100%] md:w-[90%] mx-auto mt-5'>
                            <div className='flex items-center justify-between'>
                                <label className='font-semibold text-lg'>Password</label>
                                <a onClick={() => { navigate('/forget-password?role=clubs') }} className='cursor-pointer font-semibold text-sm'>Forget Password ?</a>
                            </div>
                            <div className='relative mt-1'>
                                <input type={showPassword ? 'text' : 'password'} onChange={(e) => { setPassword(e.target.value) }}
                                    className='w-[100%] border rounded outline-none py-2 px-3'
                                />
                                <button
                                    type='button'
                                    onClick={togglePasswordVisibility}
                                    className='absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer'
                                >
                                    <FontAwesomeIcon
                                        icon={showPassword ? faEye : faEyeSlash}
                                        className='text-gray-500'
                                    />
                                </button>
                                {errors.password && <p className="text-red-400 text-sm">{errors.password}</p>}

                            </div>
                        </div>
                        <div className='flex justify-center mt-5'>
                            <button onClick={handleSubmit} className='border rounded-full flex items-center gap-2 py-[2px] pl-5 pr-[2px] cursor-pointer'>
                                <span>Sign in </span>
                                <button className='w-8 h-8 rounded-full bg-white text-black grid place-content-center'>
                                    {isLogin ? (
                                        <FontAwesomeIcon icon={faSpinner} spin />
                                    ) : (
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    )}
                                </button>
                            </button>
                        </div>
                        <p className='font-semibold text-center mt-5'>Need Help With Login ? Support</p>
                        <p className="font-semibold text-center mt-5">
                            <span onClick={() => navigate("/club/signup")} className=" cursor-pointer hover:underline">
                                Create new club
                            </span>
                        </p>
                    </div>
                    <div data-aos='fade-right' data-aos-duration='1500'>
                        <img src='/assets/others/Ball.svg' className='ball-spin absolute -bottom-10 right-3 hidden lg:block' style={{ zIndex: 1 }} />
                    </div>
                </div>
            </div>
        </div>
    )
}
